// extracted by mini-css-extract-plugin
export default {"modalBody":"CancerDateModal_modalBody__A0Zun","dropzoneWrapper":"CancerDateModal_dropzoneWrapper__qS1jP","label":"CancerDateModal_label__K1KCV"};